import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import DocumentCreationButton from 'Components/DocumentCreationButton';

const CMAP = ({ documents, startEdit }: IOwnProps): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id={'imaging.cmap'} />}
    newButton={
      <DocumentCreationButton
        name="cmap"
        text={'imaging.newcmap'}
        onClick={startEdit({}, 'cmap')}
        width={15}
        height={3}
        fontSize={14}
        alternate={true}
      />
    }
  >
    <HistoryRowListing
      documents={documents}
      headers={<></>}
      contentFormat={() => <></>}
      makeDate
      makeControls
      historyRowControls={d => <HistoryRowControls document={d} startEdit={startEdit} />}
    />
  </HistorySection>
);

interface IOwnProps {
  documents: IDocumentWithTypeV2<'cmap'>[];
  startEdit: StartEdit;
}

export default CMAP;
